import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import UsersTable from "@/components/users/users-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

const usersSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/settings/_layout/users")({
  validateSearch: usersSearchSchema,
  component: UsersPage,
});

function UsersPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "users", actions: ["read", "update"] }]}
    >
      <div>
        <div>
          <UsersTable
            currentPage={searchParams.page}
            pageSize={5}
            basePath="/settings/users"
            searchParams={searchParams}
          />
        </div>
      </div>
    </RouteGuardPermissions>
  );
}
